import { useState } from 'react';
import Select from 'components/Common/Select';
import { Control, useController } from 'react-hook-form';
import BusinessStatusConfirmModal from './BusinessStatusConfirmModal';

export type AccountStatus = 'active' | 'inactive' | 'past_due' | 'archived';

interface Props {
  control: Control<any>;
  name: string;
  businessName: string;
  label?: string;
}

const ACCOUNT_STATUS_OPTIONS: { label: string; value: AccountStatus }[] = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Past Due', value: 'past_due' },
  { label: 'Archived', value: 'archived' }
];

export default function BusinessStatusSelect({ control, name, businessName, label = 'Status' }: Props) {
  const { field } = useController({ control, name });
  const [pendingStatus, setPendingStatus] = useState<'inactive' | 'past_due' | 'archived' | null>(null);

  const handleChange = (event: { target: { value: unknown } }) => {
    const next = event.target.value as AccountStatus;
    if (next === field.value) return;

    if (next === 'active') {
      field.onChange(next);
      return;
    }

    setPendingStatus(next);
  };

  const handleConfirm = () => {
    if (!pendingStatus) return;
    field.onChange(pendingStatus);
    setPendingStatus(null);
  };

  return (
    <>
      <Select
        name={name}
        label={label}
        control={control}
        sortOrder='none'
        options={ACCOUNT_STATUS_OPTIONS}
        onChange={handleChange}
      />
      <BusinessStatusConfirmModal
        open={Boolean(pendingStatus)}
        status={pendingStatus}
        businessName={businessName}
        onClose={() => setPendingStatus(null)}
        onConfirm={handleConfirm}
      />
    </>
  );
}
